import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useModal } from '@famly/mf_modals-dialogs_context';
import { Box } from '@famly/mf_layout_box';
import { Skeleton } from '@famly/mf_feedback_skeleton';
// Hoisted to module scope so the React Compiler does not skip optimizing this hook
const loadKinderConnectCaptureModalWrapper = () => import('./kinder-connect-capture-modal-wrapper');
/**
 * Opens the KinderConnect capture modal (photo + signature + GPS) with a context provider
 * that routes the captured values to the onCapture callback.
 *
 * @returns show/hide functions for the modal.
 * @example
 * const {show} = useKinderConnectCaptureModalWithContext();
 * show({ onCapture: values => PeopleActions.checkin.dispatch(childrenIds, employeesIds, groupId, values) });
 */
export const useKinderConnectCaptureModalWithContext = () => {
    const { showModal, hideModal } = useModal({
        lazyChildren: loadKinderConnectCaptureModalWrapper,
        // 'regular' renders full screen on phone viewports — needed so the photo/signature/geolocation
        // rows have room to lay out without the fixed-height overflow scrolling 'compact' imposes.
        size: 'regular',
        skeleton: (_jsxs(Box, { children: [_jsx(Skeleton, { width: "100%", height: 42 }), _jsx(Skeleton, { width: "100%", height: 42 }), _jsx(Skeleton, { width: "100%", height: 84 })] })),
    });
    return {
        show: ({ onCapture }) => showModal({ onCapture }),
        hide: hideModal,
    };
};
